import { Integration, IntegrationStatus } from '../services/api/types';

export function IsRoyalMailOba(integration: Integration) {
  return integration.type == 'Courier' && integration.slug == 'rmoba';
}

export function HasRoyalMailOba(integration: Integration, status: IntegrationStatus) {
  return IsRoyalMailOba(integration) && !!integration.accounts.find((a) => a.status === status);
}
